import React, { useState } from "react"

// Interactive "what you'll learn" widget for the course section.
// A React island mounted into the themed landing page (mirroring the Vite +
// React integration used by save-a-life-crm). The steps below track the real
// Davis-Bacon course modules, framed as plain-language learning outcomes.

const STEPS = [
  {
    key: "foundations",
    label: "Foundations",
    icon: "uil-graduation-cap",
    outcome: "What prevailing wage is, the law behind it, and when it applies to a job.",
  },
  {
    key: "coverage",
    label: "Coverage",
    icon: "uil-shield-check",
    outcome: "Tell whether a job is covered by Davis-Bacon — and who on the crew is protected.",
  },
  {
    key: "determination",
    label: "Wage determinations",
    icon: "uil-search",
    outcome: "Find your trade and classification, then read off the right hourly rate plus fringe.",
  },
  {
    key: "paying",
    label: "Paying correctly",
    icon: "uil-usd-circle",
    outcome:
      "Get base pay, fringe benefits, overtime, and apprentices right — where the money moves.",
  },
  {
    key: "payroll",
    label: "Certified payroll",
    icon: "uil-file-check-alt",
    outcome: "Turn in clean certified payroll every week, and know why each line matters.",
  },
]

export default function ImpactCounter() {
  const [active, setActive] = useState(0)
  const step = STEPS[active]
  const progress = Math.round(((active + 1) / STEPS.length) * 100)

  return (
    <div className="card shadow-lg border-0">
      <div className="card-body p-5">
        <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
          <div>
            <h3 className="mb-1">What you’ll learn</h3>
            <p className="mb-0 text-muted">Tap a module to see what you’ll take away.</p>
          </div>
          <span className="badge bg-pale-primary text-primary rounded-pill fs-15 px-3 py-2">
            Free course
          </span>
        </div>

        <div className="progress mb-2" style={{ height: "6px" }}>
          <div
            className="progress-bar bg-primary"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Course progress"
          ></div>
        </div>
        <p className="text-muted fs-14 mb-4">
          Module {active + 1} of {STEPS.length}
        </p>

        <div className="d-flex flex-column gap-2 mb-4">
          {STEPS.map((s, i) => (
            <button
              key={s.key}
              type="button"
              className={`btn text-start d-flex align-items-center ${
                i === active ? "btn-primary" : "btn-soft-primary"
              } rounded`}
              onClick={() => setActive(i)}
              aria-pressed={i === active}
            >
              <i className={`uil ${s.icon} fs-20 me-2`}></i>
              <span className="fw-bold me-2">{i + 1}.</span>
              <span>{s.label}</span>
            </button>
          ))}
        </div>

        <div className="d-flex align-items-start bg-pale-primary rounded p-4">
          <i className="uil uil-lightbulb-alt text-primary fs-24 me-3"></i>
          <div>
            <p className="mb-1 fw-bold">What you’ll take away:</p>
            <p className="mb-0">{step.outcome}</p>
          </div>
        </div>

        <p className="text-muted fs-14 mb-0 mt-4">
          A plain-language preview — educational only, not legal advice or a compliance guarantee.
        </p>
      </div>
    </div>
  )
}
